module.exports = __webpack_public_path__ + "static/media/white-redo-measure-icon.0897cbc0.svg";